export function checkIfValid(personValue, submitted) {
  return submitted && !personValue
}
